import { GridIcon } from '@/features/experiences/components/Controls/controls/LayoutControl/GridIcon';

export const Box1RowIcon = () => {
  return (
    <GridIcon shapeProps={{ height: '48px' }} squareCols={3} squareRows={1} />
  );
};
